<template lang="pug" src="./custom-childrens-questions.pug"></template>

<script>
export default {
  data () {
    return {
      activeTabs: [0],
      showTitle: false
    }
  },
  props: ['props'],
  methods: {
    openAnswer (i) {
      !this.activeTabs.includes(i) ? this.activeTabs.push(i) : this.activeTabs.splice(this.activeTabs.indexOf(i), 1)
    },
    onWaypoint ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.showTitle = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-childrens-questions/custom-childrens-questions.vue